import React, { Fragment } from "react";
import { print } from "graphql";
import { Mutation } from "@apollo/client/react/components";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import SimpleModal from "../../SimpleModal";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import UISchemaResolver from "../../../data/schema/form_ui/_resolver";
import PrefillUtil from "../../../global/utils/prefillHelper";
import GQLUtil from "../../../global/utils/gqlHelper";
import { connect } from "react-redux";
import FormExit from "../../SimpleForm/UI/FormExit";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import {
  GET_9141_FORM_DATA,
  UPDATE_9141_FORM,
  SUBMIT_9141_FORM,
  GET_PROFILES_9141,
} from "./queries";
import { cleanData } from "./helpers.js";
import renderFormActions from "../renderFormActions";
import renderDeleteButton from "../renderDeleteButton";
import renderSaveButton from "../renderSaveButton";
import util from "../../Utils/mappers";
import isTester from "../../SimpleForm/SubmissionUtilities/isTester";
import FullScreenSpinner from "../../../global/components/FullScreenSpinner";
import { fetchAllReferenceData } from "../../../global/app/actions/actions_reference";

class Form9141 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closeModal: false,
      modalOpen: true,
      profiles: [],
      counties: undefined,
      formData:
        (this.props.history.location.state &&
          this.props.history.location.state.initialValues) ||
        {},
      form_ui: undefined,
      formSubmitting: false,
      reuse:
        (this.props.history.location.state &&
          this.props.history.location.state.reuse) ||
        false,
    };
  }

  componentDidMount = async () => {
    const application_type = "9141";
    const application_id = this.props.match.params.id;

    // if user is currently in app and reference data updates we want to fetch latest data when they open up the form
    // before we were checking if data existed in redux and if so skipping the fetch and not getting the latest data
    this.props.dispatch(fetchAllReferenceData());

    const profiles = await GQLUtil.genericGQLQuery(print(GET_PROFILES_9141));
    const profiles_parsed = PrefillUtil.getPrefillProfileOptions(
      profiles.data.getUserProfileInfo,
      application_type,
      "all"
    );

    const form = await GQLUtil.genericGQLQuery(print(GET_9141_FORM_DATA), {
      id: application_id,
    });

    util
      .getCounties()
      .then((data) => this.setState({ counties: data }))
      .catch((e) => {
        console.log(`unable to fetch counties`);
      });

    let formData = form.data.getForm9141ById.payload;
    if (form.data !== null) {
      let form_ui = form.data.getForm9141ById.form_ui;

      this.setState({
        profiles: profiles_parsed,
        formData,
        form_ui,
      });
    }

    if (
      this.props.history.location.state &&
      this.props.history.location.state.initialValues
    ) {
      this.setState({
        formData: {
          ...this.props.history.location.state.initialValues,
          ...(formData ?? {}),
        },
      });
    }
  };

  render9141 = () => {
    const application_type = "9141";
    const resolverName = "SubmitForm9141";
    const application_id = this.props.match.params.id;
    const useRecaptcha = this.props.user?.Recaptcha !== false;
    const { executeRecaptcha } = useRecaptcha
      ? this.props.googleReCaptchaProps
      : {};
    const handleToggle = () => {
      this.setState({ closeModal: !this.state.closeModal });
    };

    const renderFormExit = (values, form_ui, form_ui_name) => {
      return (
        <FormExit
          renderDeleteButton={() =>
            renderDeleteButton(
              application_id,
              application_type,
              this.props.history,
              values,
              this.props.user.GroupRole
            )
          }
          renderSaveButton={() =>
            renderSaveButton(
              UPDATE_9141_FORM,
              values,
              "Form9141FormData",
              application_id,
              cleanData,
              this.props.history,
              "Save as Initiated",
              undefined,
              undefined,
              form_ui,
              form_ui_name
            )
          }
          closeModal={this.state.closeModal}
          toggleModal={handleToggle}
          values={values}
        />
      );
    };
    const setFormSubmittingState = (booleanValue) => {
      this.setState({ formSubmitting: booleanValue });
    };

    const formSubmissionError = (e, application_id) => {
      let type;
      let error = JSON.stringify(e);
      setFormSubmittingState(false);

      if (
        e &&
        e.graphQLErrors &&
        e.graphQLErrors[0] &&
        e.graphQLErrors[0].extensions
      ) {
        error = e.graphQLErrors[0].extensions;
      }
      if (
        e &&
        e.graphQLErrors &&
        e.graphQLErrors[0] &&
        e.graphQLErrors[0].message
      ) {
        type = e.graphQLErrors[0].message;
      }
      this.props.history.push({
        pathname: "/dashboard/error",
        state: {
          formType: application_type,
          error,
          application_id,
          type,
        },
      });
    };
    const formSubmissionSuccess = (res) => {
      const queueError = res?.[`${resolverName}`] === "queue_error";
      setFormSubmittingState(false);
      this.props.history.push({
        pathname: "/dashboard/success",
        state: { formType: application_type, queueError },
      });
    };

    return (
      <Fragment>
        {!this.state.modalOpen ? (
          <Redirect to="/dashboard/application" />
        ) : (
          <SimpleModal
            fullscreen={true}
            toggleModal={handleToggle}
            modalStatus={this.state.modalOpen}
          >
            <Mutation
              onError={(e) => formSubmissionError(e, application_id)}
              onCompleted={(e) => formSubmissionSuccess(e)}
              mutation={SUBMIT_9141_FORM}
            >
              {(SubmitForm9141) => (
                <SimpleForm
                  handleSubmit={
                    useRecaptcha
                      ? async (values) => {
                          if (!executeRecaptcha) {
                            return;
                          }
                          const token = await executeRecaptcha(resolverName);
                          setFormSubmittingState(true);
                          SubmitForm9141({
                            variables: {
                              Form9141FormData: cleanData(values),
                              id: application_id,
                              token,
                            },
                          });
                        }
                      : (values) => {
                          setFormSubmittingState(true);
                          SubmitForm9141({
                            variables: {
                              Form9141FormData: cleanData(values),
                              id: application_id,
                            },
                          });
                        }
                  }
                  toggleClose={handleToggle}
                  toggleModal={handleToggle}
                  formExit={this.state.closeModal}
                  renderFormExit={renderFormExit}
                  renderFormActions={renderFormActions(
                    UPDATE_9141_FORM,
                    "Form9141FormData",
                    application_id,
                    cleanData,
                    this.props.history,
                    this.state.formSubmitting
                  )} // override default FormActions
                  formSaveMutation={UPDATE_9141_FORM}
                  formSaveMutationCallback={({
                    formValues,
                    formUIData,
                    saveForm,
                    profilePrefillMetadata,
                  }) => {
                    saveForm({
                      variables: {
                        formUI9141: formUIData,
                        Form9141FormData: cleanData(formValues),
                        id: application_id,
                        profilePrefillMetadata: profilePrefillMetadata.profiles,
                      },
                    });
                  }}
                  multiPage={true}
                  uiSchema={UISchemaResolver(application_type)}
                  uiSchema_meta={UISchemaResolver(`${application_type}-meta`)}
                  uiSchema_nav={UISchemaResolver(`${application_type}-nav`)}
                  uiSchema_lookup={UISchemaResolver(
                    `${application_type}-lookup`
                  )}
                  inputResolver={inputResolver}
                  initialValues={this.state.formData || {}}
                  profiles={this.state.profiles}
                  counties={this.state.counties}
                  form_ui={this.state.form_ui}
                  form_ui_name={"formUI9141"}
                  formSubmitting={this.state.formSubmitting}
                  returningToForm={this.state.reuse}
                  disableValidation={
                    (this.props.user &&
                      this.props.user.Roles &&
                      isTester(this.props.user && this.props.user.Roles)) ||
                    false
                  }
                />
              )}
            </Mutation>
          </SimpleModal>
        )}
      </Fragment>
    );
  };

  render() {
    if (this.state.formData !== undefined && this.state.form_ui !== undefined) {
      return <div>{this.render9141()}</div>;
    }
    return <FullScreenSpinner />;
  }
}

const mapStateToProps = (state) => ({
  user: state.appReducer.userDataReducer.data,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const ConnectedForm = connect(mapStateToProps, mapDispatchToProps)(Form9141);
const RoutedForm = withRouter(ConnectedForm);

const FormWrapper = (props) => {
  const useRecaptcha = props.user?.Recaptcha !== false;
  const ComponentToRender = useRecaptcha
    ? withGoogleReCaptcha(RoutedForm)
    : RoutedForm;

  return <ComponentToRender {...props} />;
};

export default FormWrapper;
